import { LexerEvent } from "../../text/lexer/LexerEvent";
import { ParserPhase } from "../../text/lexer/parsing/ParserPhase";
import { RJLexer } from "../RJLexer";
import { RJParser } from "../RJParser";

export class RJLexing extends ParserPhase<RJParser>
{
  static readonly phaseInfo = "RJ Lexing";
  get phaseInfo(){ return RJLexing.phaseInfo; }

  #lexer = new RJLexer();
  #events:LexerEvent[];
  get events(){ return this.#events; }

  process()
  {
    this.#events = this.#lexer.lexToList( this.parser.source );
  }


}